import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {Unite} from '../../models/Unite';
import {environment} from '../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class UniteService {
    private apiUrl = `${environment.parameters_url}api/settings/unite`;
    constructor(private http: HttpClient) {}

    getUnitePerStation(idStation: number): Observable<Unite[]> {
        return this.http.get<any>(`${this.apiUrl}/${idStation}`).pipe(
            map(response => {
               // console.log('getUnitePerStation Response:', response);
                return response.unites || [];
            }),
            catchError(this.handleError)
        );
    }

    getAll(idStation: number, idUser: number): Observable<Unite[]> {
        return this.http.get<any>(`${this.apiUrl}/${idUser}/${idStation}`).pipe(
            map(response => {
               // console.log('getAll Response:', response);
                return response.unites || [];
            }),
            catchError(this.handleError)
        );
    }

    addUnite(unite: Unite): Observable<Unite> {
       // console.log('addUnite Request:', unite);
        return this.http.post<any>(this.apiUrl, unite).pipe(
            map(response => {
               // console.log('addUnite Raw Response:', JSON.stringify(response, null, 2));
                const newUnite: Unite = response.unite || response;
              //  console.log('addUnite Mapped Unite:', newUnite);
                if (!newUnite || !newUnite.libelle || !newUnite.id) {
              //      console.warn('Invalid unite response:', newUnite);
                    throw new Error('Invalid unite response');
                }
                return newUnite;
            }),
            catchError(error => {
             //   console.error('addUnite Error:', error);
                return this.handleError(error);
            })
        );
    }

    updateUnite(unite: Unite, idStation: number): Observable<Unite> {
      //  console.log('updateUnite Request:', unite);
        return this.http.put<any>(`${this.apiUrl}/${unite.id}`, { libelle: unite.libelle }).pipe(
            map(response => {
            //    console.log('updateUnite Raw Response:', JSON.stringify(response, null, 2));
                const updatedUnite: Unite = response.unite || response;
             //   console.log('updateUnite Mapped Unite:', updatedUnite);
                if (!updatedUnite || !updatedUnite.libelle || !updatedUnite.id) {
                  //  console.warn('Invalid updated unite response:', updatedUnite);
                    throw new Error('Invalid updated unite response');
                }
                return updatedUnite;
            }),
            catchError(error => {
               // console.error('updateUnite Error:', error);
                return this.handleError(error);
            })
        );
    }

    private handleError(error: HttpErrorResponse): Observable<never> {
        let errorMessage = 'Une erreur est survenue lors de la communication avec le serveur.';
        if (error.error instanceof ErrorEvent) {
            errorMessage = `Erreur: ${error.error.message}`;
        } else {
            errorMessage = `Code d'erreur: ${error.status}\nMessage: ${error.message}`;
        }
      //  console.error('HandleError:', errorMessage);
        return throwError(() => new Error(errorMessage));
    }
}

